import { render, staticRenderFns } from "./LocationFormModal.vue?vue&type=template&id=324a4124&scoped=true&"
import script from "./LocationFormModal.vue?vue&type=script&lang=ts&"
export * from "./LocationFormModal.vue?vue&type=script&lang=ts&"
import style0 from "./LocationFormModal.vue?vue&type=style&index=0&id=324a4124&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324a4124",
  null
  
)

export default component.exports